import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=2761c460&scoped=true&"
import script from "./InputSelect.vue?vue&type=script&lang=ts&"
export * from "./InputSelect.vue?vue&type=script&lang=ts&"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=2761c460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761c460",
  null
  
)

export default component.exports